query UserAppPrivileges {
  userAppPrivileges {
    nodes {
      linkType
      id
    }
  }
}
